export default "__VITE_ASSET__dP0qsv1o__"